<template>
    <div class="max-shell">
        <div class="refund-detail-shell">
            <div class="crumbs-shell">
                当前位置：首页 > 个人中心 > 我的拼团 > 拼团详情 > 退款详情
            </div>
            <div class="order-shell">
                <div class="order-shell-h">
                    <div class="h-box" style="width: 40%">课程信息</div>
                    <div class="h-box" style="width: 20%">订单金额</div>
                    <div class="h-box" style="width: 20%">状态</div>
                    <div class="h-box" style="width: 20%">操作</div>
                </div>
                <div class="order-shell-c">
                    <div class="c-box" style="width: 40%">
                        <div class="goods-info">
                            <div class="goods-img">
                                <img :src="group_info.course_img" alt="">
                            </div>
                            <div class="goods-shell">
                                <div class="goods-name">
                                    {{order_info.order_info.course_name.length>25?order_info.order_info.course_name.substring(0,25)+'...':order_info.order_info.course_name}}
                                </div>
                                <div class="goods-type">类别：食品安全培训</div>
                                <div class="goods-type">学时：{{order_info.order_info.cnt_course}}课时</div>
                            </div>
                        </div>
                    </div>
                    <div class="c-box" style="width: 20%">
                        <div class="goods-price">￥{{order_info.pay_money}}</div>
                    </div>
                    <div class="c-box" style="width: 20%">
                        <div class="order-status">拼团失败</div>
                    </div>
                    <div class="c-box" style="width: 20%">
                        <router-link class="handle-btn"
                                     :to="'/Coursetobuy?course_id=' + order_info.order_info.course_id">
                            查看课程
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="order-info-shell">
                <div class="order-info-box">
                    <div class="info-name">退款金额：</div>
                    <div class="info-content">￥{{order_info.pay_money}}</div>
                </div>
                <div class="order-info-box">
                    <div class="info-name">用户账号：</div>
                    <div class="info-content">肖肖</div>
                </div>
                <div class="order-info-box">
                    <div class="info-name">支付方式：</div>
                    <div class="info-content">微信支付</div>
                </div>
                <div class="order-info-box">
                    <div class="info-name">退款账户：</div>
                    <div class="info-content" style="color: #2AA9B5;">微信余额</div>
                </div>
            </div>
            <div class="order-log">
                <div class="log-box">
                    <div class="log-header">
                        <div class="log-dot" style="background-color: #2aa9b5;"></div>
                        <div class="log-line"></div>
                        <div class="log-title" style="color: #2AA9B5;">{{refund_info[2].state_text}}</div>
                        <div class="log-time">{{refund_info[2].time}}</div>
                    </div>
                    <div class="log-content">{{refund_info[2].desc}}</div>
                </div>
                <div class="log-box">
                    <div class="log-header">
                        <div class="log-line2"></div>
                        <div class="log-dot"></div>
                        <div class="log-title">{{refund_info[1].state_text}}</div>
                        <div class="log-time">{{refund_info[1].time}}</div>
                    </div>
                    <div class="log-content">{{refund_info[1].desc}}</div>
                </div>
                <div class="log-box">
                    <div class="log-header">
                        <div class="log-dot"></div>
                        <div class="log-title">{{refund_info[0].state_text}}</div>
                        <div class="log-time">{{refund_info[0].time}}</div>
                    </div>
                    <div class="log-content">{{refund_info[0].desc}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'refund-detail',
    data () {
      return {
        member_id: this.$route.query.member_id,
        refund_info: [
          {
            state_text: ''
          },
          {
            state_text: ''
          },
          {
            state_text: ''
          }
        ],
        group_info: '',
        task_info: '',
        order_info: {
          order_info: {
            course_img: '',
            course_name: '1'
          }
        },
        order_id: ''
      }
    },
    mounted () {
      this.get_refund_info()
      this.get_detail()
    },
    methods: {
      get_refund_info () {
        this.API.post('user/group-refund_detail', {
          member_id: this.member_id
        }).then((res) => {
          if (res.errno == 0) {
            this.refund_info = res.data.refund_info
          }
        })
      },
      get_detail () {
        this.API.post('user/group-order_detail', {
          member_id: this.member_id,
        }).then((res) => {
          this.group_info = res.data.group_info
          this.task_info = res.data.task_info
          this.order_id = this.task_info.order_id
          this.get_order_detail()
        })
      },
      get_order_detail () {
        this.API.post('user/user_infos-order_detail', {
          order_id: this.order_id
        }).then((res) => {
          this.order_info = res.data.order_info
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .max-shell {
        width: 100%;
        min-height: 100vh;
        background-color: #f4f4f4;

        .refund-detail-shell {
            width: 1200px;
            margin: 0 auto;
        }

        .crumbs-shell {
            display: flex;
            align-items: center;
            height: 100px;
        }
    }

    .order-shell {
        background-color: #fff;
        width: 1200px;

        .order-shell-h {
            display: flex;
            align-items: center;
            height: 60px;
            width: 100%;
            background-color: #f8f8f8;

            .h-box {
                text-align: center;
            }
        }

        .order-shell-c {
            display: flex;
            align-items: center;
            height: 170px;
            width: 100%;
            background-color: #fff;

            .c-box {
            }

            .goods-price {
                text-align: center;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #EB2020;
            }

            .order-status {
                text-align: center;
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
            }

            .handle-btn {
                text-align: center;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #2AA9B5;
            }


            .goods-info {
                display: flex;
                align-items: center;
                padding: 10px;

                .goods-img {
                    width: 183px;
                    min-width: 183px;
                    height: 110px;
                    border: 1px solid #eee;
                    margin-right: 10px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .goods-shell {
                    .goods-name {
                        font-size: 18px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        -o-text-overflow: ellipsis; /* for Opera */
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }

                    .goods-type, .order-status {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #999999;
                    }
                }
            }
        }
    }

    .order-info-shell {
        background-color: #fff;
        height: 254px;
        margin-top: 15px;
        padding: 20px;

        .order-info-box {
            display: flex;
            align-items: center;
            height: 25%;

            .info-name {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;
            }

            .info-content {
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
            }
        }
    }

    .order-log {
        background-color: #fff;
        margin-top: 15px;
        padding: 20px;
        margin-bottom: 30px;
        position: relative;

        .log-box {
            position: relative;
        }

        .log-header {
            display: flex;
            align-items: center;
            margin-bottom: 27px;

            .log-dot {
                width: 12px;
                height: 12px;
                background: #D2D2D2;
                border-radius: 50%;
                margin-right: 15px;
            }

            .log-title {
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
                margin-right: 20px;
            }

            .log-time {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #999999;
            }
        }

        .log-line {
            position: absolute;
            top: 22px;
            left: 6px;
            width: 1px;
            height: 140%;
            background: #F1F1F1;
        }

        .log-line2 {
            position: absolute;
            top: 22px;
            left: 6px;
            width: 1px;
            height: 140%;
            background: #F1F1F1;
        }

        .log-content {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            padding-bottom: 32px;
            margin-bottom: 55px;
            border-bottom: 1px solid #eee;
            margin-left: 20px;
        }
    }
</style>
